/**
 * 017 T023: the upward `apps/isomorphic/src/layouts/use-layout` import is dropped.
 *
 * `useLayout` existed only to vary this badge across the template's six interchangeable layouts
 * (hydrogen, lithium, beryllium, boron, carbon, helium). `apps/admin` uses one — Hydrogen — so the
 * `classes.layout[...]` lookups always resolved to `undefined` here and are removed with the hook.
 * `classes.layout` itself is kept as-is, unused, so the diff against the vendor file stays legible.
 *
 * NOTE: nothing in `apps/admin` is built on this component. This product's status vocabulary lives
 * in `components/table-utils/get-status-badge.tsx`, which carries 17 states and a real fallback;
 * this one is a two-branch `status === 'new'` guess (research R5). It is copied because
 * `components/cards/*` import it.
 */
import { Badge } from 'rizzui';
import cn from '../utils/class-names';

const classes = {
  base: 'text-xs px-2 duration-200 py-0.5 font-normal capitalize border tracking-wider font-lexend bg-opacity-50 dark:bg-opacity-40 dark:text-opacity-90 dark:text-gray-900 dark:backdrop-blur',
  color: {
    success: 'border-green bg-green-lighter text-green-dark dark:bg-green',
    danger: 'border-red bg-red-lighter text-red-dark dark:bg-red',
  },
  layout: {
    helium: {
      base: 'bg-opacity-40 text-opacity-90 text-gray-0 dark:text-gray-900 backdrop-blur group-hover:bg-opacity-100 group-hover:text-opacity-100',
      success: 'bg-green',
      danger: 'bg-red',
    },
  },
};

export default function StatusBadge({ status }: { status: string }) {
  const colorStatus = status?.toLowerCase() === 'new' ? 'danger' : 'success';

  return (
    <Badge
      variant="flat"
      size="sm"
      color={colorStatus}
      className={cn(
        classes.base,
        classes.color[colorStatus]
      )}
    >
      {status}
    </Badge>
  );
}
